import { render, staticRenderFns } from "./TickMarkIcon.vue?vue&type=template&id=1b0a59b6&"
import script from "./TickMarkIcon.vue?vue&type=script&lang=js&"
export * from "./TickMarkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports